export default {
    en: {
        buttonText: 'Close'
    },
    fr: {
        buttonText: 'Fermer'
    }
};
